module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/3@2x_7392c3d60dc184346a6993d8323fcb19.png";